import { gql } from '@apollo/client';

const PublicProfileQuery = gql`
  query PublicProfile {
    public: publicPortfolioCurrentUser {
      firstname
      lastname
      avatarUrl
      configuration {
        isPublic
      }
    }
  }
`;

export default PublicProfileQuery;
